<template>
    <NuxtLayout name="default">
        <div class="w-full">
            <layout-maintenance class="mt-12 mb-12" />

            <slot />

            <layout-footer />
        </div>
    </NuxtLayout>
</template>
